(() => {
  const init = () => {
    document.querySelectorAll('[data-cn250-film]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const tile = button.closest('.cn250-film');
      const video = tile?.querySelector('video');
      if (!video) return;
      const status = tile.querySelector('[role=status]');
      button.addEventListener('click', async () => {
        status.textContent = '';
        document.querySelectorAll('.cn250-film video').forEach(other => {if (other !== video) other.pause();});
        button.hidden = true;
        try {await video.play();} catch {button.hidden = false;status.textContent = 'Playback could not start. Please try again.';}
      });
      video.addEventListener('ended', () => {button.hidden = false;});
      video.addEventListener('error', () => {button.hidden = false;});
    });
    document.querySelectorAll('.cn250-care-nav a').forEach(link => {
      const url = new URL(link.href);
      if (url.pathname === location.pathname && url.search === location.search) link.setAttribute('aria-current','page');
    });
    const policy = document.querySelector('.shopify-policy__container');
    if (policy && !policy.classList.contains('cn250-policy')) {
      policy.classList.add('cn250-policy');
      const source = policy.querySelector('.shopify-policy__body');
      const links = document.querySelector('#cn250-care-links');
      if (source && links) {
        const layout = document.createElement('div');layout.className = 'cn250-care-layout';
        source.before(layout);layout.append(links.content.cloneNode(true));
        const article = document.createElement('article');article.className='cn250-care-body';layout.append(article);article.append(source);
        const headings = [...source.querySelectorAll('h2,h3')];
        source.querySelectorAll('p').forEach(paragraph => {
          const strong=paragraph.querySelector('strong');
          if(strong && paragraph.textContent.trim()===strong.textContent.trim() && paragraph.textContent.trim().length<140){
            paragraph.classList.add('cn250-policy-heading');
            paragraph.setAttribute('role','heading');paragraph.setAttribute('aria-level','2');
            headings.push(paragraph);
          }
        });
        const firstHeading=source.querySelector('h1,h2,p');
        if(firstHeading && firstHeading.textContent.trim().length<65 && /policy|terms of service|legal notice/i.test(firstHeading.textContent)){
          firstHeading.classList.add('cn250-policy-title-repeat');
          const duplicateIndex=headings.indexOf(firstHeading);if(duplicateIndex>=0)headings.splice(duplicateIndex,1);
        }
        const currentLink=[...layout.querySelectorAll('.cn250-care-nav a')].find(link=>new URL(link.href).pathname===location.pathname);
        const title=policy.querySelector('.shopify-policy__title h1');
        if(currentLink && title) title.textContent=currentLink.textContent;
        if (headings.length) {
          const details=document.createElement('details');details.className='cn250-section-index';
          const summary=document.createElement('summary');summary.textContent=document.body.dataset.cn250Contents||'On this page';
          const nav=document.createElement('nav');nav.setAttribute('aria-label',summary.textContent);
          headings.forEach((heading,index) => {if(!heading.id) heading.id='cn250-policy-section-'+index;const a=document.createElement('a');a.href='#'+heading.id;a.textContent=heading.textContent;nav.append(a);});
          details.append(summary,nav);article.prepend(details);
        }
        layout.querySelectorAll('.cn250-care-nav a').forEach(link=>{if(new URL(link.href).pathname===location.pathname)link.setAttribute('aria-current','page');});
      }
    }
  };
  init();
  document.addEventListener('shopify:section:load',init);
})();
